import { ConfigCliente } from '../../../configuracoes/app/cliente';

import { ClienteAnaliseMercadoSearchViewCliente } from '../cliente-analise-mercado-search-view-cliente';
import { ClienteAnaliseMercadoSearchCliente } from '../cliente-analise-mercado-search-cliente';
import { ClienteAnaliseMercadoSearchClienteTotal } from '../cliente-analise-mercado-search-cliente-total';

export class ClienteAnaliseMercadoClienteList {
    private clientes: Map<number, ClienteAnaliseMercadoSearchCliente>;
    private idsClientesToSearch: number[];
    quantidadeClientes: number;
    total: ClienteAnaliseMercadoSearchClienteTotal;

    /** Quantidade limite de clientes que devem ser retornados nas pesquisa sob-demanda */
    private limit: number;
    /** Se atingiu o fim da pesquisa sob-demanda dos clientes na list */
    done: boolean;

    constructor(searchView: ClienteAnaliseMercadoSearchViewCliente, limit: number) {
        this.clientes = new Map<number, ClienteAnaliseMercadoSearchCliente>();
        this.quantidadeClientes = 0;
        this.idsClientesToSearch = [];
        this.limit = limit;
        this.createClientes(searchView);
        this.createTotal(searchView);
    }

    /** Cria e adiciona os clientes com base no Search View */
    private createClientes(searchView: ClienteAnaliseMercadoSearchViewCliente) {
        if (!searchView.total) {
            return;
        }

        this.idsClientesToSearch = searchView.idsClientes;
        this.quantidadeClientes = searchView.quantidadeClientes;
        if (searchView.firstClientes && searchView.firstClientes.length > 0) {
            this.addClientes(searchView.firstClientes);
        }
    }

    /** Obtendo os clientes adicionados na list */
    getClientes(): ClienteAnaliseMercadoSearchCliente[] {
        return Array.from(this.clientes.values());
    }

    /** Adiciona os clientes informados nos clientes da list */
    addClientes(clientes: ClienteAnaliseMercadoSearchCliente[]) {
        if (!clientes || clientes.length === 0) {
            return;
        }

        clientes.forEach(cliente => {
            this.clientes.set(cliente.idCliente, cliente);
        });

        // Verificando se atingiu o fim da pesquisa quando a quantidade de clientes já adicionados na list for igual ou maior que a quantidade de clientes
        this.done = this.clientes.size >= this.quantidadeClientes;
    }

    /** Obtem os IDs dos próximos clientes para serem pesquisados */
    getMoreClientes(): number[] {
        const starIndex = this.clientes.size;
        let endIndex: number;
        if ((starIndex + this.limit) <= this.quantidadeClientes) {
            endIndex = starIndex + this.limit;
        } else {
            endIndex = undefined;
        }

        return this.idsClientesToSearch.slice(starIndex, endIndex);
    }

    /** Atualiza o cliente informado */
    updateOneCliente(cliente: ClienteAnaliseMercadoSearchCliente, configCliente: ConfigCliente) {
        if (!cliente || !this.clientes) {
            return;
        }

        const clienteAtual = this.clientes.get(cliente.idCliente);
        if (clienteAtual) {
            // Primeiro removemos os valores atuais do cliente do total
            this.total.removeCliente(clienteAtual, configCliente);
        }

        // Depois atualizamos ou inserimos o cliente e adicionamos os seus novos valores no total
        this.clientes.set(cliente.idCliente, cliente);
        this.total.addCliente(cliente, configCliente);
        this.quantidadeClientes = this.clientes.size;
    }

    /** Remove o cliente informado */
    removeOneCliente(idCliente: number, configCliente: ConfigCliente) {
        const cliente = this.clientes.get(idCliente);
        if (cliente) {
            const removido = this.clientes.delete(cliente.idCliente);
            this.total.removeCliente(cliente, configCliente);
            this.quantidadeClientes = this.clientes.size;
        }
    }

    /** Cria e adiciona o total com base no total do Search View */
    private createTotal(searchView: ClienteAnaliseMercadoSearchViewCliente) {
        this.total = new ClienteAnaliseMercadoSearchClienteTotal();
        if (!searchView.total) {
            return;
        }

        // Quantidade Potencial
        this.total.quantidadePotencial = searchView.total.quantidadePotencial;
        // Peso Potencial
        this.total.pesoPotencial = searchView.total.pesoPotencial;
        // Valor Potencial
        this.total.valorPotencial = searchView.total.valorPotencial;

        // Quantidade Pretendida
        this.total.quantidadePretendida = searchView.total.quantidadePretendida;
        this.total.quantidadePretendidaPerc = searchView.total.quantidadePretendidaPerc;
        // Peso Pretendido
        this.total.pesoPretendido = searchView.total.pesoPretendido;
        this.total.pesoPretendidoPerc = searchView.total.pesoPretendidoPerc;
        // Valor Pretendido
        this.total.valorPretendido = searchView.total.valorPretendido;
        this.total.valorPretendidoPerc = searchView.total.valorPretendidoPerc;
        this.total.indicadorCustomerSharePretendido = searchView.total.indicadorCustomerSharePretendido;

        // Quantidade Projetada
        this.total.quantidadeProjetada = searchView.total.quantidadeProjetada;
        this.total.quantidadeProjetadaPerc = searchView.total.quantidadeProjetadaPerc;
        // Peso Projetado
        this.total.pesoProjetado = searchView.total.pesoProjetado;
        this.total.pesoProjetadoPerc = searchView.total.pesoProjetadoPerc;
        // Valor Projetado
        this.total.valorProjetado = searchView.total.valorProjetado;
        this.total.valorProjetadoPerc = searchView.total.valorProjetadoPerc;

        // Quantidade Realizada
        this.total.quantidadeRealizada = searchView.total.quantidadeRealizada;
        this.total.quantidadeRealizadaPercPretendida = searchView.total.quantidadeRealizadaPercPretendida;
        this.total.quantidadeRealizadaPercProjetada = searchView.total.quantidadeRealizadaPercProjetada;
        // Peso Realizado
        this.total.pesoRealizado = searchView.total.pesoRealizado;
        this.total.pesoRealizadoPercPretendido = searchView.total.pesoRealizadoPercPretendido;
        this.total.pesoRealizadoPercProjetado = searchView.total.pesoRealizadoPercProjetado;
        // Valor Realizado
        this.total.valorRealizado = searchView.total.valorRealizado;
        this.total.valorRealizadoPerc = searchView.total.valorRealizadoPerc;
        this.total.indicadorCustomerShareRealizado = searchView.total.indicadorCustomerShareRealizado;
        this.total.valorRealizadoPercPretendido = searchView.total.valorRealizadoPercPretendido;
        this.total.valorRealizadoPercProjetado = searchView.total.valorRealizadoPercProjetado;
    }
}
